import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { Button } from 'react-bootstrap';

const MoveToTop = () => {
  const [showButton, setShowButton] = useState(false);

  // Function to handle scroll-to-top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  // Check scroll position to display button
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {showButton && (
        <Button
          variant="primary"
          className="move-to-top d-flex align-items-center justify-content-center"
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: '1000',
            borderRadius: '50%',
            padding: '10px',
            fontSize: '24px',
          }}
        >
          <FaArrowUp />
        </Button>
      )}
    </>
  );
};

export default MoveToTop;
